<!-- 客户基础信息 -->
<template>
  <div class="wraps">
    <div class="form">
      <p class="tip">账号信息</p>
      <el-form :form="form" :disabled="true" :inline="true" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="注册邮箱：">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核状态：">
              <el-input v-model="status"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 自然人隐藏企业信息 -->
    <div class="form"  v-if="userType != '2'">
      <p class="tip">企业信息</p>
      <el-form :form="form" :disabled="true" :inline="true" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="公司名称：">
              <el-input v-model="form.epName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一身份信用代码：">
              <el-input v-model="form.creditCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="法人：">
              <el-input v-model="form.representative"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属行业：">
              <el-input v-model="category"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="APPID：">
              <el-input v-model="form.appId"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构公钥：">
              <el-input v-model="form.pubKey"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="机构ID：">
              <el-input v-model="form.epId"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="userType != '2'">
            <el-form-item class="busiLincese" label="营业执照：">
              <div class="img-box">
                <img v-if="busiLinceseType === 'pdf'" :src="pdfIcon" alt="" />
                <img v-else :src="busiLinceseImg" alt="" />
              </div>
              <div
                v-loading="!busiLinceseImg"
                @click="viewImg(busiLinceseImg, busiLinceseType)"
                class="click-box"
              ></div>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="officialLetterType">
            <el-form-item class="officialLetter" label="委托公函：">
              <div class="img-box">
                <img
                  v-if="officialLetterType === 'pdf'"
                  :src="pdfIcon"
                  alt=""
                />
                <img v-else :src="officialLetterImg" alt="" />
              </div>
              <div
                v-loading="!officialLetterImg"
                @click="viewImg(officialLetterImg, officialLetterType)"
                class="click-box"
              ></div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="form">
      <p class="tip">申请人信息</p>
      <el-form :form="form" :disabled="true" :inline="true" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请人：">
              <el-input v-model="form.contact"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：">
              <el-input v-model="form.mobile"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="申请人职务：">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号码：">
              <el-input v-model="form.idcard"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="用户ID">
              <el-input v-model="form.userId"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item class="busiLincese" label="身份证正面：">
              <div class="img-box">
                <img v-if="cardFrontType === 'pdf'" :src="pdfIcon" alt="" />
                <img v-else :src="cardBackImg" alt="" />
              </div>
              <div
                v-loading="!cardBackImg"
                @click="viewImg(cardBackImg, cardFrontType)"
                class="click-box"
              ></div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="officialLetter" label="身份证反面：">
              <div class="img-box">
                <img v-if="cardBackType === 'pdf'" :src="pdfIcon" alt="" />
                <img v-else :src="cardFrontImg" alt="" />
              </div>
              <div
                v-loading="!cardFrontImg"
                @click="viewImg(cardFrontImg, cardBackType)"
                class="click-box"
              ></div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="form" v-if="!showAgent && !agentCustomer">
      <p class="tip">客户其他信息</p>
      <el-form :form="form" :disabled="true" :inline="true" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户渠道：">
              <el-input v-model="customerChannel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理商：">
              <el-input v-model="form.beAgentCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="推荐码：">
              <el-input v-model="form.recommendCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template v-if="getUserIdentity != 4">
        <div class="btns" v-if="form.state === 1">
          <el-button @click="refuseClick" class="refuse">驳回</el-button>
          <el-button @click="adoptClick" type="primary" class="adopt"
            >通过</el-button
          >
        </div>
      </template>
    </div>
    <div class="form" v-if="showAgent">
      <p class="tip">其他信息</p>
      <el-form :form="form" :disabled="true" :inline="true" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="代理商代码">
              <el-input v-model="form.agentCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理客户数：">
              <el-input v-model="form.agentCustomerNum"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 代理商代理的用户其他信息显示 -->
    <div class="form" v-if="!showAgent && agentCustomer">
      <p class="tip">其他信息</p>
      <el-form :form="form" :disabled="true" :inline="true" label-width="150px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户渠道：">
              <el-input v-model="customerChannel"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理商：">
              <el-input v-model="form.beAgentCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="平台名称：">
              <el-input v-model="form.platformName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="平台地址：">
              <el-input v-model="form.platformUrl"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="平台类型：">
              <el-input v-model="form.businessType"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-dialog
      :append-to-body="true"
      width="600px"
      class="img-dialog"
      :visible.sync="imgDialog"
    >
      <iframe
        v-if="viewType === 'pdf'"
        frameborder="0"
        width="100%"
        :src="previewImg"
        alt=""
      >
        This browser does not support PDFs. Please download the PDF to view it:
        <a :href="previewImg">Download PDF</a>
      </iframe>
      <img v-else :src="previewImg" style="width: 100%" alt="" />
    </el-dialog>
    <el-dialog
      class="audit-dialog"
      :append-to-body="true"
      title="提示"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <p style="text-align: center;line-height: 60px">
        确定要
        <span style="font-size: 16px;color: #2049A3">通过</span
        >该客户认证申请吗？
      </p>
      <div class="item-style">
        <span style="margin-right: 15px">客户类型</span>
        <el-radio v-model="isAgent" :label="false">客户</el-radio>
        <el-radio v-model="isAgent" :label="true"  :disabled="isAgented">代理商</el-radio>
        <el-radio v-model="isAgent" label="isPlatform" >数字资产平台</el-radio>
      </div>
      <div class="item-style">
        <span style="margin-right: 15px">企业归属</span>
        <!-- <el-radio v-model="belongs" :label="1">腾讯链</el-radio>
      <el-radio v-model="belongs" :label="2">网安链</el-radio> -->
        <el-radio v-model="belongs" :label="1">腾讯内部</el-radio>
        <el-radio v-model="belongs" :disabled="disableBelongs" :label="2">官⽹客户</el-radio>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="clicked || !belongs"
          round
          type="primary"
          @click="auth(2)"
          >确定通过</el-button
        >
        <el-button round @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="refuse-dialog"
      :append-to-body="true"
      title="提示"
      :visible.sync="refuseDialogVisible"
      width="30%"
    >
      <p style="text-align: center;line-height: 60px">
        确定要
        <span style="font-size: 16px;color: #2049A3">驳回</span
        >该客户认证申请吗？
      </p>
      <el-input
        style="width: 70%"
        resize="none"
        maxlength="128"
        type="textarea"
        :rows="2"
        placeholder="请输入理由"
        v-model="refuseReason"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <!-- :disabled="clicked || !refuseReason" -->
        <el-button round type="primary" @click="auth(3)">确定驳回</el-button>
        <el-button round @click="refuseDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Api from "@/api";
import { statusCode } from "@/config";
import { setStorageItem, getStorageItem, removeStorageItem } from "@/utils";

export default {
  name: "BaseInfo",
  components: {},
  props: {
    isShowAgent: {
      type: Boolean,
      default: false,
    },
    agentCustomer:{
      type: Boolean,
      default: false,
    },
    userType:{}
  },
  data() {
    return {
      showAgent: false,
      customerChannel: "",
      imgDialog: false,
      busiLinceseImg: "",
      officialLetterImg: "",
      cardBackImg: "",
      cardFrontImg: "",
      dialogVisible: false,
      refuseDialogVisible: false,
      clicked: false,
      refuseReason: "",
      belongs: null,
      isAgent: false,
      previewImg: "",
      category: "",
      form: {},
      busiLinceseType: "img", // 营业执照类型，默认为pdf
      officialLetterType: "img",
      cardBackType: "img",
      cardFrontType: "img",
      pdfIcon: require("@/views/customerManagement/img/pdf.png"),
      viewType: "img", // 预览图类型，默认为pdf
      isAgented:false // 是否被代理
    };
  },
  created() {
    this.form = getStorageItem("epDetail");
    console.log("sssssssssssssss",this.form)
    switch (this.form.state) {
      case 1:
        this.status = "待审核";
        break;
      case 2:
        this.status = "已通过";
        break;
      case 3:
        this.status = "未通过";
        break;
      default:
        this.status = "";
    }
    // 0客户未定，保留留以前模式， 2官⽹网客户， 1腾讯内部
    switch (this.form.customerChannel) {
      case 0:
        this.customerChannel = "客户未定";
        break;
      case 2:
        this.customerChannel = "官⽹客户";
        break;
      case 1:
        this.customerChannel = "腾讯内部";
        break;
      default:
        this.customerChannel = "";
    }
    //如果详情里面有beAgentCode或者beAgentId就是被代理过，审核时不能选择代理商
    if(this.form.beAgentCode || this.form.beAgentId){
      this.isAgented= true;
    }
    this.getBusiLinceseImg(this.form.busilicenseid);
    this.getOfficialLetterImg(this.form.officialLetterId);
    this.getCardFrontImg(this.form.idcardbackid);
    this.getCardBackImg(this.form.idcardfrontid);
    this.form.categoryPid &&  this.getCategory()
  },
  computed: {
    getUserIdentity() {
      return getStorageItem("loginInfo").roleID;
    },
    disableBelongs(){
      return !!this.isAgent
    }
  },
  mounted() {
    this.showAgent = this.isShowAgent;
  },
  watch:{
     isAgent(val) {
        if(val){
          this.belongs = 1
        }
      }
  },
  methods: {
    getCategory() {
      Api.customer
        .getCategory(this.form.categoryPid)
        .then((res) => {
          if (res.retCode === statusCode.SUCCESS) {
            this.category = res.detail[0].name;
          } else {
            this.$message.closeAll();
            this.$message({
              showClose: true,
              message: res.retMsg,
              type: "error",
            });
          }
        })
        .catch(() => {});
    },
    adoptClick() {
      this.belongs = null;
      this.dialogVisible = true;
    },
    refuseClick() {
      this.refuseReason = "";
      this.refuseDialogVisible = true;
    },
    auth(state) {
      let that = this;
      const req = {
        epId: this.form.epId,
        state,
        reason: state === 2 ? "ok" : this.refuseReason,
      };
      if (state === 2) {
        req.belongs = this.belongs;
        req.isAgent = this.isAgent;
        // 通过时候,添加用户身份
        // this.$router.push({
        //   name: 'customerAuditList',
        // })
      }
      this.clicked = true;
      const regHtml = /<[^>]+>/g;
      if (regHtml.test(req.reason)) {
        this.$message({
          showClose: true,
          message: "禁止输入html标签,请输入相关的文字说明",
          type: "error",
        });
        return false;
      }
      if(req.isAgent == 'isPlatform'){
        req.isPlatform = 1
        req.isAgent = true
      }else{
        req.isPlatform = 0
      }
      Api.customer
        .authUser(req)
        .then((res) => {
          if (res.retCode === statusCode.SUCCESS) {
            this.refuseDialogVisible = false;
            this.dialogVisible = false;
            this.form.state = state;
            switch (this.form.state) {
              case 1:
                this.status = "待审核";
                break;
              case 2:
                this.status = "已通过";
                break;
              case 3:
                this.status = "未通过";
                break;
              default:
                this.status = "";
            }
            //这里添加代理商代码和代理客户数
            setStorageItem("epDetail", this.form);
            this.$message({
              showClose: true,
              message: "操作成功",
              type: "success",
            });
            that.$router.push({
              name: "customerAuditList",
            });
          } else {
            this.$message.closeAll();
            this.$message({
              showClose: true,
              message: res.retMsg,
              type: "error",
            });
          }
          this.clicked = false;
        })
        .catch(() => {
          this.clicked = false;
        });
    },
    viewImg(url, type) {
      this.previewImg = url;
      this.viewType = type;
      const isIE = window.ActiveXObject || "ActiveXObject" in window;
      if (isIE && this.viewType === "pdf") {
        this.$confirm(
          '<i style="font-size: 54px;color: #D34349;" class="el-icon-warning"></i><span style="font-size:16px;position: relative;top: -10px;margin-left: 10px;">该浏览器暂不支持pdf预览，推荐使用chrome浏览器</span>',
          "提示",
          {
            confirmButtonText: "确定",
            dangerouslyUseHTMLString: true,
            center: true,
            showCancelButton: false,
            confirmButtonClass: "comfirm",
          }
        ).then(() => {});
      } else {
        this.imgDialog = true;
      }
    },
    getOfficialLetterImg(id) {
      Api.user
        .downloadletter(id)
        .then(
          (res) =>
            `data:${res.headers["content-type"]};base64,${btoa(
              new Uint8Array(res.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            )}`
        )
        .then((res) => {
          this.officialLetterImg = res;
          if (res.indexOf("application/pdf") !== -1) {
            this.officialLetterType = "pdf";
          } else if(res.indexOf("data:application/json")!==-1){
            this.officialLetterType = false
          } else {
            this.officialLetterType = "img";
          }
        });
    },
    getBusiLinceseImg(id) {
      let _userType =  this.$route.query.userType
      if(_userType != 2){ // 自然人不显示营业执照
           Api.user
          .downBusiLincense(id)
          .then(
            (res) =>
              `data:${res.headers["content-type"]};base64,${btoa(
                new Uint8Array(res.data).reduce(
                  (data, byte) => data + String.fromCharCode(byte),
                  ""
                )
              )}`
          )
          .then((res) => {
            this.busiLinceseImg = res;
            if (res.indexOf("application/pdf") !== -1) {
              this.busiLinceseType = "pdf";
            } else {
              this.busiLinceseType = "img";
            }
          }).catch(err=>{
            console.log("err",err)
          })
      }
    },
    getCardFrontImg(id) {
      Api.user
        .downloadCardFront(id)
        .then(
          (res) =>
            `data:${res.headers["content-type"]};base64,${btoa(
              new Uint8Array(res.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            )}`
        )
        .then((res) => {
          this.cardFrontImg = res;
          if (res.indexOf("application/pdf") !== -1) {
            this.cardFrontType = "pdf";
          } else {
            this.cardFrontType = "img";
          }
        });
    },
    getCardBackImg(id) {
      Api.user
        .downloadCardBack(id)
        .then(
          (res) =>
            `data:${res.headers["content-type"]};base64,${btoa(
              new Uint8Array(res.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            )}`
        )
        .then((res) => {
          this.cardBackImg = res;
          if (res.indexOf("application/pdf") !== -1) {
            this.cardBackType = "pdf";
          } else {
            this.cardBckType = "img";
          }
        });
    },
  },
};
</script>

<style lang="scss">
.audit-dialog {
  .el-dialog__body {
    // text-align: center;
    margin:0 30px;
  }
  /deep/ .el-dialog .el-dialog__footer {
    margin-top: 0;
  }
}
</style>

<style lang="scss" scoped>
.wraps {
  // border:1px solid red;
}
.form {
  display: flex;
  flex-wrap: wrap;
  // border:1px solid green;
  width: 885px;
  margin: 0 auto;
  // justify-content: center;
  .tip {
    line-height: 80px;
    margin-left: 40px;
    color: #333333;
    position: relative;
    padding-left: 10px;
    width: 100%;
  }
  .tip::before {
    height: 16px;
    background-color: #2455ce;
    position: absolute;
    content: "";
    width: 4px;
    left: 0;
    top: 32px;
  }
  .el-form {
    // width: 900px;
    margin-top: 30px;
    .el-form-item {
      /deep/ .el-input.is-disabled .el-input__inner {
        color: #696d75;
      }
      .el-input {
        width: 280px;
      }
      .busiLincese,
      .officialLetter {
        position: relative;
      }
      .click-box {
        width: 100px;
        height: 120px;
        position: absolute;
        overflow: hidden;
        top: 0;
        cursor: pointer;
      }
      .img-box {
        width: 100px;
        height: 120px;
        overflow: hidden;
      }
      img {
        width: 100px;
        cursor: pointer;
      }
    }
  }
  .btns {
    margin-top: 40px;
    width: 100%;
    text-align: center;
    .refuse {
      color: #0034b3;
      border-color: #0034b3;
      width: 150px;
      height: 50px;
      margin-right: 60px;
    }
    .adopt {
      width: 150px;
      height: 50px;
      background-color: #1d60c0;
    }
    margin-bottom: 50px;
  }
}
.el-dialog__wrapper {
  text-align: center;
  img {
    width: 100%;
  }
  .dialog-footer {
    margin-top: -20px;
    text-align: center;
    .el-button {
      width: 134px;
    }
  }
  /deep/ .el-dialog__footer {
    text-align: center;
  }
  .item-style{
    padding:5px 0;
    text-align: left;
  }
}
</style>
